export default __webpack_public_path__ + "static/media/bg.d3baaeeb.svg";